module.exports = __webpack_public_path__ + "kobieta_obiad.jpg?1614d5c25cce9a03d9b4cb72e13008f5";


//////////////////
// WEBPACK FOOTER
// ./IMG/kobieta_obiad.jpg
// module id = 126
// module chunks = 0